module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_3.55c65fc1.png";